import { render, staticRenderFns } from "./SamSkuDetail.vue?vue&type=template&id=acc2fe12&scoped=true"
import script from "./SamSkuDetail.vue?vue&type=script&lang=js"
export * from "./SamSkuDetail.vue?vue&type=script&lang=js"
import style0 from "./SamSkuDetail.vue?vue&type=style&index=0&id=acc2fe12&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc2fe12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acc2fe12')) {
      api.createRecord('acc2fe12', component.options)
    } else {
      api.reload('acc2fe12', component.options)
    }
    module.hot.accept("./SamSkuDetail.vue?vue&type=template&id=acc2fe12&scoped=true", function () {
      api.rerender('acc2fe12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jdStore/samSkuList/components/SamSkuDetail.vue"
export default component.exports